<template>
	<v-col cols="12" lg="12" class="pa-0">
		<v-card flat class="pa-0">
			<v-card-text class="pa-0">
				<v-row>
					<v-col v-if="data.length > 1" class="pa-0">
						<GChart type="ColumnChart" :data="data" :options="chartOptions" />
					</v-col>
					<v-col v-else class="d-flex justify-center">{{ $t('labels.noData') }}</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-col>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
	name: 'NumberOfCandidatesChart',
	components: { GChart },
	props: {
		data: Array,
	},
	data: function () {
		return {
			chartOptions: {
				title: 'Prikaz broja kandidata po centrima',
				legend: { position: 'bottom' },
				height: 500,
				colors: ['#92d050'],
			},
		};
	},

	methods: {},
};
</script>

<style scoped></style>
